<div [formGroup]="group" class="cc-root">
  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <!--  SECTION 1 — CHAT WINDOW                                              -->
  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <div class="cc-section">
    <div
      class="cc-section-header"
      (click)="chatWindowOpen = !chatWindowOpen"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="chatWindowOpen"
      (keydown.enter)="chatWindowOpen = !chatWindowOpen"
      (keydown.space)="$event.preventDefault(); chatWindowOpen = !chatWindowOpen"
    >
      <div class="cc-section-header-left">
        <mat-icon class="cc-section-icon">chat_bubble_outline</mat-icon>
        <span class="cc-section-title">Chat Window</span>
      </div>
      <mat-icon class="cc-chevron" [class.cc-chevron--open]="chatWindowOpen">expand_more</mat-icon>
    </div>

    @if (chatWindowOpen) {
      <div class="cc-section-body">
        <!-- 1 · Header Background Color ─────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-headerBackgroundColor">Header Background Color</label>
          <div class="cc-color-row">
            <input
              id="cc-headerBackgroundColor"
              type="text"
              formControlName="headerBackgroundColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p1.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p1.click()"
              (keydown.space)="p1.click()"
            >
              <div class="cc-swatch" [style.background]="cv('headerBackgroundColor')"></div>
              <input
                #p1
                type="color"
                class="cc-color-hidden"
                [value]="cv('headerBackgroundColor')"
                (input)="onColorInput($event, 'headerBackgroundColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The background color of the chatbot header bar.</p>
        </div>

        <!-- 2 · Header Text Color ───────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-headerTextColor">Header Text Color</label>
          <div class="cc-color-row">
            <input
              id="cc-headerTextColor"
              type="text"
              formControlName="headerTextColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p2.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p2.click()"
              (keydown.space)="p2.click()"
            >
              <div class="cc-swatch" [style.background]="cv('headerTextColor')"></div>
              <input
                #p2
                type="color"
                class="cc-color-hidden"
                [value]="cv('headerTextColor')"
                (input)="onColorInput($event, 'headerTextColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The color of the text displayed in the chatbot header.</p>
        </div>

        <!-- 3 · Header Font ─────────────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-headerFont">Header Font</label>
          <select id="cc-headerFont" formControlName="headerFont" class="cc-select">
            @for (opt of fontOptions; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
          <p class="cc-hint">The font used for text in the chatbot header.</p>
        </div>

        <!-- 4 · Bot Message Bubble Color ───────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-botMessageBubbleColor">Bot Message Bubble Color</label>
          <div class="cc-color-row">
            <input
              id="cc-botMessageBubbleColor"
              type="text"
              formControlName="botMessageBubbleColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p4.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p4.click()"
              (keydown.space)="p4.click()"
            >
              <div class="cc-swatch" [style.background]="cv('botMessageBubbleColor')"></div>
              <input
                #p4
                type="color"
                class="cc-color-hidden"
                [value]="cv('botMessageBubbleColor')"
                (input)="onColorInput($event, 'botMessageBubbleColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The background color of the bubbles containing AI responses.</p>
        </div>

        <!-- 5 · Customer Message Bubble Color ──────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-customerMessageBubbleColor">Customer Message Bubble Color</label>
          <div class="cc-color-row">
            <input
              id="cc-customerMessageBubbleColor"
              type="text"
              formControlName="customerMessageBubbleColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p5.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p5.click()"
              (keydown.space)="p5.click()"
            >
              <div class="cc-swatch" [style.background]="cv('customerMessageBubbleColor')"></div>
              <input
                #p5
                type="color"
                class="cc-color-hidden"
                [value]="cv('customerMessageBubbleColor')"
                (input)="onColorInput($event, 'customerMessageBubbleColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The background color of the bubbles containing the customer's messages.</p>
        </div>

        <!-- 6 · Chat Bubble Background Color ───────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-chatBubbleBackgroundColor">Chat Bubble Background Color</label>
          <div class="cc-color-row">
            <input
              id="cc-chatBubbleBackgroundColor"
              type="text"
              formControlName="chatBubbleBackgroundColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p6.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p6.click()"
              (keydown.space)="p6.click()"
            >
              <div class="cc-swatch" [style.background]="cv('chatBubbleBackgroundColor')"></div>
              <input
                #p6
                type="color"
                class="cc-color-hidden"
                [value]="cv('chatBubbleBackgroundColor')"
                (input)="onColorInput($event, 'chatBubbleBackgroundColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The background color of the interactive bubbles inside the chat popup.</p>
        </div>

        <!-- 7 · Chat Bubble Text Color ─────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-chatBubbleTextColor">Chat Bubble Text Color</label>
          <div class="cc-color-row">
            <input
              id="cc-chatBubbleTextColor"
              type="text"
              formControlName="chatBubbleTextColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p7.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p7.click()"
              (keydown.space)="p7.click()"
            >
              <div class="cc-swatch" [style.background]="cv('chatBubbleTextColor')"></div>
              <input
                #p7
                type="color"
                class="cc-color-hidden"
                [value]="cv('chatBubbleTextColor')"
                (input)="onColorInput($event, 'chatBubbleTextColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The color of the text displayed inside the interactive chat bubbles.</p>
        </div>

        <!-- 8 · Chat Bubble Font ────────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-chatBubbleFont">Chat Bubble Font</label>
          <select id="cc-chatBubbleFont" formControlName="chatBubbleFont" class="cc-select">
            @for (opt of fontOptions; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
          <p class="cc-hint">The font used for text inside the interactive chat bubbles.</p>
        </div>

        <!-- 9 · Chat Bubble Text Size (connected toggle) ───────────────── -->
        <div class="cc-field">
          <label class="cc-label">Chat Bubble Text Size</label>
          <div class="cc-toggle-group">
            @for (opt of textSizeOptions; track opt.value) {
              <button
                type="button"
                class="cc-toggle-btn"
                [class.cc-toggle-active]="ctrlChatBubbleTextSize === opt.value"
                (click)="setToggle('chatBubbleTextSize', opt.value)"
              >
                {{ opt.label }}
              </button>
            }
          </div>
          <p class="cc-hint">The size of the text inside the interactive chat bubbles.</p>
        </div>

        <!-- 10 · Header Logo (file upload) ─────────────────────────────── -->
        <div class="cc-field">
          <label id="cc-headerLogo-label" class="cc-label">Header Logo</label>
          <input
            #logoFileInput
            type="file"
            class="cc-hidden"
            accept=".svg,.png,.jpg,.jpeg"
            (change)="onLogoSelected($event)"
          />

          <div
            class="cc-upload-area"
            (click)="logoFileInput.click()"
            role="button"
            tabindex="0"
            aria-labelledby="cc-headerLogo-label"
            aria-describedby="cc-headerLogo-hint"
            (keydown.enter)="logoFileInput.click()"
            (keydown.space)="logoFileInput.click()"
          >
            @if (previewLogo) {
              <img [src]="$any(previewLogo)" alt="Logo preview" class="cc-upload-preview" />
              @if (logoFileName) {
                <span class="cc-upload-filename">{{ logoFileName }}</span>
              }
              <button type="button" class="cc-upload-remove" (click)="removeLogo($event)">Remove logo</button>
            } @else {
              <mat-icon class="cc-upload-icon">cloud_upload</mat-icon>
              <span class="cc-upload-cta">Select file</span>
              <span id="cc-headerLogo-hint" class="cc-upload-sub">SVG (recommended) | PNG, JPG (500×500)</span>
            }
          </div>
        </div>

        <!-- Chat Window Preview -->
        <div class="cc-field mt-6">
          <label class="cc-label">Chat Window Preview</label>
          <div class="cc-preview-container">
            <!-- Simulated Browser Header -->
            <div class="cc-mock-browser-header">
              <div class="cc-mock-dots">
                <span class="cc-mock-dot cc-mock-dot--red"></span>
                <span class="cc-mock-dot cc-mock-dot--yellow"></span>
                <span class="cc-mock-dot cc-mock-dot--green"></span>
              </div>
              <span class="cc-preview-badge">Preview</span>
            </div>

            <!-- Simulated Chat Header -->
            <div class="cc-preview-header" [ngStyle]="debouncedHeaderStyle">
              @if (previewLogo) {
                <img [src]="$any(previewLogo)" class="cc-preview-header-logo" alt="" />
              } @else {
                <div
                  class="flex items-center justify-center w-4 h-4 rounded-full text-[8px] uppercase bg-gray-200 text-[#616161]"
                >
                  A
                </div>
              }
              <span class="cc-preview-header-title">Aiva Bot</span>
            </div>

            <!-- Simulated Chat Area -->
            <div class="cc-preview-chat" style="padding-bottom: 12px" [ngStyle]="debouncedChatAreaStyle">
              <div
                class="cc-preview-bubble cc-preview-bubble--bot"
                [ngStyle]="debouncedBotBubbleStyle"
                [style.font-size]="bubbleFontSize()"
              >
                Hi! How can we help you today?
              </div>
              <div
                class="cc-preview-bubble cc-preview-bubble--user"
                [ngStyle]="debouncedUserBubbleStyle"
                [style.font-size]="bubbleFontSize()"
              >
                I'd like to schedule a service appointment.
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /cc-section-body chat-window -->
    }
  </div>
  <!-- /section 1 -->

  <!-- ── Section divider ─────────────────────────────────────────────────── -->
  <div class="cc-divider"></div>

  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <!--  SECTION 2 — CHAT LAUNCHER BUTTON                                     -->
  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <div class="cc-section">
    <div
      class="cc-section-header"
      (click)="chatLauncherOpen = !chatLauncherOpen"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="chatLauncherOpen"
      (keydown.enter)="chatLauncherOpen = !chatLauncherOpen"
      (keydown.space)="$event.preventDefault(); chatLauncherOpen = !chatLauncherOpen"
    >
      <div class="cc-section-header-left">
        <mat-icon class="cc-section-icon">ads_click</mat-icon>
        <span class="cc-section-title">Chat Launcher Button</span>
      </div>
      <mat-icon class="cc-chevron" [class.cc-chevron--open]="chatLauncherOpen">expand_more</mat-icon>
    </div>

    @if (chatLauncherOpen) {
      <div class="cc-section-body">
        <!-- 11 · Chat Button Color ──────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-chatButtonColor">Chat Button Color</label>
          <div class="cc-color-row">
            <input
              id="cc-chatButtonColor"
              type="text"
              formControlName="chatButtonColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p11.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p11.click()"
              (keydown.space)="p11.click()"
            >
              <div class="cc-swatch" [style.background]="cv('chatButtonColor')"></div>
              <input
                #p11
                type="color"
                class="cc-color-hidden"
                [value]="cv('chatButtonColor')"
                (input)="onColorInput($event, 'chatButtonColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The background color of the chat launcher button on the dealer's website.</p>
        </div>

        <!-- 12 · Chat Button Text Color ────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-chatButtonTextColor">Chat Button Text Color</label>
          <div class="cc-color-row">
            <input
              id="cc-chatButtonTextColor"
              type="text"
              formControlName="chatButtonTextColor"
              class="cc-text-input cc-text-input--flex"
            />
            <div
              class="cc-swatch-wrap"
              (click)="p12.click()"
              role="button"
              tabindex="0"
              aria-label="Open color picker"
              (keydown.enter)="p12.click()"
              (keydown.space)="p12.click()"
            >
              <div class="cc-swatch" [style.background]="cv('chatButtonTextColor')"></div>
              <input
                #p12
                type="color"
                class="cc-color-hidden"
                [value]="cv('chatButtonTextColor')"
                (input)="onColorInput($event, 'chatButtonTextColor')"
              />
            </div>
          </div>
          <p class="cc-hint">The color of the text on the chat launcher button.</p>
        </div>

        <!-- 13 · Chat Button Label (with character counter) ────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-chatButtonLabel">Chat Button Label</label>
          <input
            id="cc-chatButtonLabel"
            type="text"
            formControlName="chatButtonLabel"
            class="cc-text-input cc-text-input--full"
            maxlength="40"
            placeholder="Schedule Service"
          />
          <div class="cc-counter-row">
            <p class="cc-hint">The text displayed on the chat launcher button. Keep it short and clear.</p>
            <span class="cc-counter" [class.cc-counter--warn]="ctrlLabelLength >= 38">
              {{ ctrlLabelLength }}&thinsp;/&thinsp;40
            </span>
          </div>
        </div>

        <!-- 14 · Chat Button Size (connected toggle, 4 options) ─────────── -->
        <div class="cc-field">
          <label class="cc-label">Chat Button Size</label>
          <div class="cc-toggle-group">
            @for (opt of buttonSizeOptions; track opt.value) {
              <button
                type="button"
                class="cc-toggle-btn"
                [class.cc-toggle-active]="ctrlChatButtonSize === opt.value"
                (click)="setToggle('chatButtonSize', opt.value)"
              >
                {{ opt.label }}
              </button>
            }
          </div>
          <p class="cc-hint">Choose a preset, or pick Custom to fine-tune the exact size.</p>
        </div>

        <!-- 15 · Button Font ────────────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-buttonFont">Button Font</label>
          <select id="cc-buttonFont" formControlName="buttonFont" class="cc-select">
            @for (opt of fontOptions; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
          <p class="cc-hint">The typeface used for the chat launcher button label.</p>
        </div>

        <!-- 16 · Font Weight (chip-wrap toggle, 6 options) ─────────────── -->
        <div class="cc-field">
          <label class="cc-label">Font Weight</label>
          <div class="cc-toggle-group cc-toggle-group--chips">
            @for (opt of fontWeightOptions; track opt.value) {
              <button
                type="button"
                class="cc-toggle-btn cc-toggle-btn--chip"
                [class.cc-toggle-active]="ctrlFontWeight === opt.value"
                (click)="setToggle('fontWeight', opt.value)"
              >
                {{ opt.label }}
              </button>
            }
          </div>
        </div>

        <!-- 17 · Button Style (spaced, not connected) ───────────────────── -->
        <div class="cc-field">
          <label class="cc-label">Button Style</label>
          <div class="cc-toggle-group cc-toggle-group--spaced">
            @for (opt of buttonStyleOptions; track opt.value) {
              <button
                type="button"
                class="cc-toggle-btn cc-toggle-btn--spaced"
                [class.cc-toggle-active]="ctrlButtonStyle === opt.value"
                (click)="setToggle('buttonStyle', opt.value)"
              >
                {{ opt.label }}
              </button>
            }
          </div>
          <p class="cc-hint">Controls the shape of the chat launcher button.</p>
        </div>

        <!-- 18 · Button Placement (2×2 grid) ───────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label">Button Placement</label>
          <div class="cc-placement-grid">
            @for (opt of placementOptions; track opt.id) {
              <button
                type="button"
                class="cc-placement-btn"
                [class.cc-placement-active]="ctrlButtonPlacement === opt.id"
                (click)="setToggle('buttonPlacement', opt.id)"
              >
                <span class="cc-placement-arrow">{{ opt.arrow }}</span>
                <span class="cc-placement-label">{{ opt.label }}</span>
              </button>
            }
          </div>
          <p class="cc-hint">Choose which corner of the dealer's website the launcher sits in.</p>
        </div>

        <!-- 19 · Horizontal Offset (range slider) ──────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-horizontalOffset">Horizontal Offset</label>
          <div class="cc-slider-row">
            <input
              id="cc-horizontalOffset"
              type="range"
              min="0"
              max="100"
              step="1"
              formControlName="horizontalOffset"
              class="cc-range"
            />
            <span class="cc-slider-value">{{ cv('horizontalOffset') }}px</span>
          </div>
        </div>

        <!-- 20 · Vertical Offset (range slider) ────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label" for="cc-verticalOffset">Vertical Offset</label>
          <div class="cc-slider-row">
            <input
              id="cc-verticalOffset"
              type="range"
              min="0"
              max="100"
              step="1"
              formControlName="verticalOffset"
              class="cc-range"
            />
            <span class="cc-slider-value">{{ cv('verticalOffset') }}px</span>
          </div>
        </div>

        <!-- 21 · Advanced Margin Control (iOS toggle + expandable grid) ── -->
        <div class="cc-field">
          <div class="cc-toggle-row">
            <div class="cc-toggle-row-text">
              <span class="cc-label cc-label--inline">Advanced Margin Control</span>
              <p class="cc-hint cc-hint--tight">Set top, right, bottom, and left margins individually.</p>
            </div>
            <div
              class="cc-ios-toggle"
              (click)="toggleAdvancedMargin()"
              role="switch"
              tabindex="0"
              aria-label="Advanced Margin Control"
              [attr.aria-checked]="ctrlAdvancedMarginOn"
              (keydown.enter)="toggleAdvancedMargin()"
              (keydown.space)="$event.preventDefault(); toggleAdvancedMargin()"
            >
              <span class="cc-ios-track" [class.cc-ios-track--on]="ctrlAdvancedMarginOn">
                <span class="cc-ios-thumb" [class.cc-ios-thumb--on]="ctrlAdvancedMarginOn"></span>
              </span>
            </div>
          </div>

          @if (ctrlAdvancedMarginOn) {
            <div class="cc-margin-grid">
              <div class="cc-margin-cell">
                <label class="cc-sub-label" for="cc-marginTop">Top</label>
                <input
                  id="cc-marginTop"
                  type="text"
                  formControlName="marginTop"
                  class="cc-text-input cc-text-input--full"
                  placeholder="auto"
                />
              </div>
              <div class="cc-margin-cell">
                <label class="cc-sub-label" for="cc-marginRight">Right</label>
                <input
                  id="cc-marginRight"
                  type="text"
                  formControlName="marginRight"
                  class="cc-text-input cc-text-input--full"
                  placeholder="auto"
                />
              </div>
              <div class="cc-margin-cell">
                <label class="cc-sub-label" for="cc-marginBottom">Bottom</label>
                <input
                  id="cc-marginBottom"
                  type="text"
                  formControlName="marginBottom"
                  class="cc-text-input cc-text-input--full"
                  placeholder="auto"
                />
              </div>
              <div class="cc-margin-cell">
                <label class="cc-sub-label" for="cc-marginLeft">Left</label>
                <input
                  id="cc-marginLeft"
                  type="text"
                  formControlName="marginLeft"
                  class="cc-text-input cc-text-input--full"
                  placeholder="auto"
                />
              </div>
            </div>
          }
        </div>

        <!-- 22 · Layering / Z-Index ─────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label">Layering (Z-Index)</label>
          <p class="cc-hint cc-hint--gap">Controls stacking order. Range: 0–9999.</p>

          <div class="cc-sub-field">
            <label class="cc-sub-label" for="cc-chatButtonZIndex">Chat Button Z-Index</label>
            <div class="cc-slider-row">
              <input
                id="cc-chatButtonZIndex"
                type="range"
                min="0"
                max="9999"
                step="1"
                formControlName="chatButtonZIndex"
                class="cc-range"
              />
              <span class="cc-slider-value">{{ cv('chatButtonZIndex') }}</span>
            </div>
          </div>

          <div class="cc-sub-field">
            <label class="cc-sub-label" for="cc-chatWindowZIndex">Chat Window Z-Index</label>
            <div class="cc-slider-row">
              <input
                id="cc-chatWindowZIndex"
                type="range"
                min="0"
                max="9999"
                step="1"
                formControlName="chatWindowZIndex"
                class="cc-range"
              />
              <span class="cc-slider-value">{{ cv('chatWindowZIndex') }}</span>
            </div>
          </div>
        </div>

        <!-- 23 · Button Preview ─────────────────────────────────────────── -->
        <div class="cc-field">
          <label class="cc-label">Button Preview</label>
          <div class="cc-preview-container">
            <!-- Simulated Browser Header -->
            <div class="cc-mock-browser-header">
              <div class="cc-mock-dots">
                <span class="cc-mock-dot cc-mock-dot--red"></span>
                <span class="cc-mock-dot cc-mock-dot--yellow"></span>
                <span class="cc-mock-dot cc-mock-dot--green"></span>
              </div>
              <!-- Preview Badge -->
              <span class="cc-preview-badge">Preview</span>
            </div>

            <!-- Launcher button (absolute, placement-driven, with debounced values) -->
            <button type="button" [ngStyle]="debouncedPreviewStyle">
              @if (previewLogo) {
                <img [src]="$any(previewLogo)" class="cc-preview-btn-logo" alt="" />
              }
              <span class="cc-preview-btn-text">{{ debouncedLabel }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /cc-section-body chat-launcher -->
    }
  </div>
  <!-- /section 2 -->
</div>
<!-- /cc-root -->
